import type { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  PosSelect,
  type PosSelectProps,
} from 'pos-client/components/shared/Form/PosSelect.tsx';
import { useLocale } from 'pos-client/hooks/useStaticConfig.tsx';
import { Locale } from 'pos-client/locales/locale.ts';

import { STATES, STATES_AU } from './states.ts';

export const StateSelect = <
  TFieldValues extends FieldValues = FieldValues,
  ValueType extends string = string,
>(
  props: PosSelectProps<TFieldValues, ValueType> & { localeOverride?: Locale }
) => {
  const { t } = useTranslation();
  const { locale, isLoadingLocale } = useLocale();

  const placeholder =
    props.placeholder ??
    t('common.placeholders.selectField', {
      field: t('common.address.state'),
    });

  const selectStatesFromLocale = () => {
    const resolvedLocale = props.localeOverride ?? locale;

    switch (resolvedLocale) {
      case Locale.EN_US:
        return STATES;
      case Locale.EN_AU:
        return STATES_AU;
      default:
        return [];
    }
  };

  const options = selectStatesFromLocale();

  if (props.control) {
    const { control, name, label } = props;
    return (
      <PosSelect
        {...props}
        control={control}
        name={name}
        options={options}
        placeholder={placeholder}
        label={label ?? t('common.address.state')}
        showSearch
        allowClear
        loading={isLoadingLocale}
      />
    );
  }

  return (
    <PosSelect
      {...props}
      options={options}
      placeholder={placeholder}
      showSearch
      allowClear
      loading={isLoadingLocale}
    />
  );
};
